import { SubAPI } from "./SubAPI";
export class Receiving extends SubAPI {
    list(input) { return this.fetcher.get("/api/logistics/receiving/pending", input); }
    updateItem(input) { return this.fetcher.post("/api/logistics/receiving/item", input); }
    upsert(input) { return this.fetcher.post("/api/logistics/receiving", input); }
    get(input) { return this.fetcher.get("/api/logistics/receiving", input); }
    listItems(input) { return this.fetcher.get("/api/logistics/receiving/items", input); }
    updateItems(input) { return this.fetcher.post("/api/logistics/receiving/items", input); }
}
